import classNames from "classnames";
import React, { InputHTMLAttributes } from "react";
import { CheckBoxProps } from "@common/types";
import { Text } from "../text";

export const variants = {
  success:
    "border-success/65 bg-card text-success accent-success hover:border-success checked:!border-success checked:!bg-success focus-visible:ring-success/25",
  danger:
    "border-destructive/70 bg-card text-destructive accent-[hsl(var(--destructive))] hover:border-destructive checked:!border-destructive checked:!bg-destructive focus-visible:ring-destructive/25",
  disabled:
    "cursor-not-allowed border-border-strong bg-muted/80 text-muted-foreground accent-muted-foreground checked:!border-muted-foreground checked:!bg-muted-foreground",
  default:
    "border-border-strong bg-card text-primary accent-primary hover:border-primary/60 checked:!border-primary checked:!bg-primary focus-visible:ring-primary/25",
};

export const CheckBox = React.forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> &
    CheckBoxProps & { inputClassName?: string }
>(function CheckBox(
  {
    label,
    className,
    inputClassName,
    hint,
    error,
    block,
    success,
    onChange,
    onInputChange,
    icon,
    iconPosition,
    ...props
  },
  ref,
) {
  const errorMessage = error
    ? typeof error === "string"
      ? error
      : typeof error === "object"
        ? error.message
        : false
    : false;

  const variant = error
    ? "danger"
    : success
      ? "success"
      : props.disabled
        ? "disabled"
        : "default";

  return (
    <div>
      <label
        className={classNames(
          "min-h-10 items-center py-2 md:min-h-0 md:py-0",
          className,
          block ? "flex" : "inline-flex",
        )}
      >
        <input
          type="checkbox"
          className={classNames(
            "h-4 w-4 rounded border shadow-none transition-colors focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-100",
            variants[variant],
            inputClassName,
          )}
          ref={ref}
          onChange={(e) => {
            onChange?.(e);
            onInputChange?.(e.currentTarget.checked);
          }}
          {...props}
        />
        {label && (
          <Text
            className="ms-2 font-medium"
            variant={variant}
            icon={icon}
            iconPosition={iconPosition}
          >
            {label}
          </Text>
        )}
      </label>
      {hint && (
        <Text variant="muted" block className="mt-2">
          {hint}
        </Text>
      )}
      {errorMessage ? (
        <Text variant="danger" className="mt-2 text-xs">
          {errorMessage}
        </Text>
      ) : success ? (
        <Text variant="success" className="mt-2 text-xs">
          {success}
        </Text>
      ) : null}
    </div>
  );
});
